import * as components from './components'

export default [
  {
    path: '/minsk',
    name: 'minsk',
    component: components.minskDocuments
  }
]
